import React, { ElementType, ReactElement } from 'react';
import type { RouteComponentProps } from 'react-router-dom';
import useAuthenticationState from '~/ducks/authentication/use-authentication-state';
import TrackingRedirect from '~/components/views/tracking/TrackingRedirect/TrackingRedirect';
import {
  setUptimeDestination,
  setUptimeDiamGroupId,
} from '~/utils/local-storage-utils/local-storage-utils';
import { composeUptimeLoginUrl, getDiamGroupId } from '~/domain/uptime/utils/utils';
import SplashScreen from '~/components/views/SplashScreen/SplashScreen';

export default function withAuthentication(
  WrappedComponent: ElementType,
  shouldPassThroughProps = true
) {
  return function WithAuthentication(props: RouteComponentProps): ReactElement {
    const authentication = useAuthenticationState();
    const diamGroupId = getDiamGroupId();

    // Redirect user if it is not authenticated
    if (!authentication?.authenticated) {
      if (diamGroupId) {
        setUptimeDiamGroupId(diamGroupId);
        setUptimeDestination(window.location.href);
        window.location.assign(composeUptimeLoginUrl());
        return <SplashScreen />;
      }
      //Prevent user to get stuck in an infinite loop of logging in and getting kicked out
      const from = authentication.error?.status === 401 ? null : props.location;
      return (
        <>
          <SplashScreen />
          <TrackingRedirect
            to={{
              pathname: authentication.loginPage,
              state: { from },
            }}
            tracking={{
              label: 'User is not authenticated',
            }}
          />
        </>
      );
    }

    if (shouldPassThroughProps) {
      return <WrappedComponent {...props} />;
    }

    return <WrappedComponent />;
  };
}
